import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { btnRed, dmy, F, field } from "@/components/stable/ui";

const EMPTY = { title: "", date: "", end_date: "", deadline: "", location: "", discipline: "", level: "", link: "", notes: "" };

export const AdminCompetitions = () => {
  const [list, setList] = useState([]);
  const [f, setF] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/competitions").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    const body = { ...f, end_date: f.end_date || null, deadline: f.deadline || null };
    try { if (editing) await api.put(`/admin/competitions/${editing}`, body); else await api.post("/admin/competitions", body); toast.success("Concurso guardado"); setF(EMPTY); setEditing(null); load(); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="grid lg:grid-cols-[1fr_1.2fr] gap-8" data-testid="admin-competitions">
      <form onSubmit={save} className="grid grid-cols-2 gap-3 border border-slate-200 rounded p-5 h-fit">
        <h3 className="col-span-2 font-display font-bold text-xl text-[#0B1D3A]">{editing ? "Editar concurso" : "Publicar concurso"}</h3>
        <F label="Nombre *" className="col-span-2"><input required maxLength={140} value={f.title} onChange={set("title")} className={field} data-testid="ac-title" /></F>
        <F label="Fecha *"><input required type="date" value={f.date} onChange={set("date")} className={field} data-testid="ac-date" /></F>
        <F label="Hasta"><input type="date" value={f.end_date || ""} onChange={set("end_date")} className={field} data-testid="ac-end" /></F>
        <F label="Cierre inscripción"><input type="date" value={f.deadline || ""} onChange={set("deadline")} className={field} data-testid="ac-deadline" /></F>
        <F label="Lugar"><input maxLength={140} value={f.location} onChange={set("location")} className={field} data-testid="ac-location" /></F>
        <F label="Disciplina"><input maxLength={60} value={f.discipline} onChange={set("discipline")} placeholder="Salto, Doma…" className={field} data-testid="ac-discipline" /></F>
        <F label="Nivel / categoría"><input maxLength={60} value={f.level} onChange={set("level")} className={field} data-testid="ac-level" /></F>
        <F label="Enlace de inscripción (https://)" className="col-span-2"><input maxLength={300} pattern="https://.*" value={f.link} onChange={set("link")} className={field} data-testid="ac-link" /></F>
        <F label="Notas" className="col-span-2"><textarea rows={2} maxLength={1000} value={f.notes} onChange={set("notes")} className={`${field} h-auto py-2`} data-testid="ac-notes" /></F>
        <button className={`${btnRed} col-span-2`} data-testid="ac-save">{editing ? "Guardar cambios" : "Publicar"}</button>
      </form>
      <ul className="divide-y divide-slate-100 border border-slate-200 rounded">
        {!list.length && <li className="p-4 text-sm text-slate-500">Sin concursos publicados.</li>}
        {list.map((c) => (
          <li key={c.id} className="p-4 flex justify-between gap-3 text-sm" data-testid={`ac-row-${c.id}`}>
            <div><b className="text-[#0B1D3A]">{c.title}</b><p className="text-slate-500">{dmy(c.date)} · {c.location}{c.deadline ? ` · cierre ${dmy(c.deadline)}` : ""}</p></div>
            <div className="flex gap-1">
              <button onClick={() => { setEditing(c.id); setF({ ...EMPTY, ...Object.fromEntries(Object.entries(c).map(([k, v]) => [k, v ?? ""])) }); }} className="p-2 text-slate-500 hover:text-[#2563EB]" data-testid={`ac-edit-${c.id}`}><Pencil size={15} /></button>
              <button onClick={async () => { if (window.confirm("¿Borrar este concurso?")) { await api.delete(`/admin/competitions/${c.id}`); load(); } }} className="p-2 text-slate-400 hover:text-[#DC2626]" data-testid={`ac-delete-${c.id}`}><Trash2 size={15} /></button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const AdminListings = () => {
  const [list, setList] = useState([]);
  const [paid, setPaid] = useState([]);
  const load = () => { api.get("/admin/listings").then((r) => setList(r.data)); api.get("/admin/feature-payments").then((r) => setPaid(r.data)); };
  useEffect(() => { load(); }, []);
  const real = paid.filter((p) => !p.test_payment);
  return (
    <div data-testid="admin-listings">
      <p className="text-sm text-slate-600 mb-2">Los anuncios se publican al instante. Retira los que no cumplan las normas.</p>
      <p className="text-sm mb-4" data-testid="admin-feature-income">Anuncios destacados cobrados: <b>{real.length}</b> · {real.reduce((a, p) => a + p.amount, 0).toFixed(2).replace(".", ",")} €{paid.length > real.length ? ` (${paid.length - real.length} pagos de PRUEBA no cuentan)` : ""}</p>
      <ul className="divide-y divide-slate-100 border border-slate-200 rounded">
        {!list.length && <li className="p-4 text-sm text-slate-500">Todavía no hay anuncios.</li>}
        {list.map((x) => (
          <li key={x.id} className="p-4 flex justify-between gap-3 text-sm" data-testid={`al-row-${x.id}`}>
            <div><Link to={`/mercado/${x.id}`} className="font-bold text-[#0B1D3A] hover:text-[#DC2626]">{x.title}</Link><p className="text-slate-500">{x.email} · {new Date(x.created_at).toLocaleDateString("es-ES")} · {x.status}{x.featured ? (x.featured_test ? " · ★ destacado de PRUEBA (1 h)" : " · ★ destacado") : ""}</p></div>
            {x.status !== "retirado" && <button onClick={async () => { if (window.confirm("¿Retirar este anuncio?")) { await api.post(`/admin/listings/${x.id}/remove`); load(); } }} className="text-[#DC2626] font-bold" data-testid={`al-remove-${x.id}`}>Retirar</button>}
          </li>
        ))}
      </ul>
    </div>
  );
};
